import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@mountayaapp/locales";

/**
 * resolveLanguage derives the active documentation language from a URL pathname
 * by reading its first path segment (e.g. "/en/authentication/" -> "en"). The
 * segment is clamped to a supported language, falling back to "en" when it is
 * absent or unrecognized. This is the seam that lets the docs site serve
 * language-prefixed URLs: only English ships today, and a second language lights
 * up here the moment its content and bundles exist, with no change to this
 * resolution rule.
 */
export const resolveLanguage = (pathname: string): SupportedLanguage => {
  const [segment] = pathname.split("/").filter(Boolean);

  return SUPPORTED_LANGUAGES.includes(segment as SupportedLanguage)
    ? (segment as SupportedLanguage)
    : "en";
};
